module.exports = __webpack_public_path__ + "assets/img/ab_info.5470dbd8.png";